import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  cardContainer: {
    maxWidth: 360,
    width: '100%',
    height: 153,
    borderRadius: 11,
    backgroundColor: '#f1edec',
    backgroundImage: `url("data:image/svg+xml,%3csvg width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%' height='100%' fill='none' rx='11' ry='11' stroke='%23784A42FF' stroke-width='4' stroke-dasharray='11' stroke-dashoffset='13' stroke-linecap='square'/%3e%3c/svg%3e");`,

    '@media (max-width: 767px)': {
      maxWidth: '100%'
    }
  },

  cardContent: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '100%',
    padding: 16,
    flexDirection: 'column'
  },

  cardIcons: {
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',

    '& svg': {
      width: 28,
      height: 28,

      '& path': {
        fill: theme.palette.primary.main
      }
    }
  },

  cardInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 16
  },

  cardInfoTextTotal: {
    color: theme.palette.primary.main,
    fontSize: 48,
    fontWeight: 700,
    textAlign: 'end'
  },

  cardInfoTextLabel: {
    color: theme.palette.primary.main,
    fontSize: 14,
    width: 'max-content'
  },

  cardInfoFooterContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },

  cardInfoFooterContent: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center'
  },

  cardInfoFooterLabel: {
    marginRight: '7px',
    color: theme.palette.primary.main
  }
}))
